module.exports = __webpack_public_path__ + "img/ios-american-football.f5ad3ee8.svg";